module.exports = __webpack_public_path__ + "media/packs/images/star-shipment-012babe599c0591327b44ed59c284cb1.svg";